import React, { useState, useEffect } from 'react';
import './TimerCard.css';

function formatTime(ms=1200000) {
  if (ms <= 0) return { hours: 0, minutes: 0, seconds: 0, formatted: '0: 00: 00' };
  const totalSeconds = Math.floor(ms / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  const formatted = `${hours}: ${String(minutes).padStart(2, '0')}: ${String(seconds).padStart(2, '0')}`;
  return { hours, minutes, seconds, formatted };
}

function TimerCard({ timeMs = 0 }) {
  const [remainingMs, setRemainingMs] = useState(Math.max(0, timeMs));

  useEffect(() => {
    setRemainingMs((prev) => Math.max(0, timeMs));
  }, [timeMs]);

  useEffect(() => {
    if (remainingMs <= 0) return;
    const id = setInterval(() => {
      setRemainingMs((prev) => {
        const next = prev - 1000;
        return next <= 0 ? 0 : next;
      });
    }, 1000);
    return () => clearInterval(id);
  }, [remainingMs]);

  const { formatted } = formatTime(remainingMs);

  return (
    <div className="timer-card">
      <span className="timer-card-label">ENDS IN:</span>
      <span className="timer-card-time">{formatted}</span>
    </div>
  );
}

export default TimerCard;
